import { isCmSharedLoaded } from './env'

// set up short-hand access to CM Shared Utils
// useful to avoid needing ES Lint hints all over when accessing the global GLG ns

/** See API Reference for CM Shared: https://github.com/glg/cm-shared/ */
let CMX = {
    isLoaded: false,
};

if (isCmSharedLoaded()) {
    /* global GLG */
    CMX = {
        /** Any app usage of these APIs may want to check this before attempting to call APIs, if they could be called outside of the main check in index.jsx.
        */
        isLoaded: true,
        /** GLG Cmx-specific i18n helpers. See https://github.com/glg/cm-shared/blob/master/src/i18n.js */
        i18n: GLG.Cmx.i18n,
        /** See https://github.com/glg/cm-shared/#glgcmxnavigation-api */
        Navigation: GLG.Cmx.Navigation,
        /** See https://github.com/glg/cm-shared/#glgcmxusershow-api */
        Show: GLG.Cmx.User.Show,
        /** See https://github.com/glg/cm-shared/#glgcmxtracking-api */
        Tracking: GLG.Cmx.Tracking,
        /** See https://github.com/glg/cm-shared/#glgcmxformatting-api */
        Formatting: GLG.Cmx.Formatting,
        /** See https://github.com/glg/cm-shared/#glgcmxuser-api */
        User: GLG.Cmx.User,
    }
}

export {
    /**
     * Importable proxy to CM Shared APIs.
     *
     * See API Reference for CM Shared: https://github.com/glg/cm-shared/
     * */
    CMX
};